import { render } from "./PhotoReports.vue?vue&type=template&id=1cb87d70&scoped=true"
import script from "./PhotoReports.vue?vue&type=script&lang=js"
export * from "./PhotoReports.vue?vue&type=script&lang=js"

import "./PhotoReports.vue?vue&type=style&index=0&id=1cb87d70&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb87d70"]])

export default __exports__